import React, { useEffect, useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material'
import useIsMobile from '../../../../helpers/useIsMobile'
import { DEBRIEF_FIELDS } from './catalogue'
import useLiveRecord from './useLiveRecord'

// Hot debrief (STOP5-style) stored at criticalCare.debrief + completedAt
const DebriefDialog = ({ open, onClose }) => {
  const { formValues, updateRecord } = useLiveRecord()
  const isMobile = useIsMobile('sm')
  const [values, setValues] = useState({})

  useEffect(() => {
    if (open) setValues(formValues?.criticalCare?.debrief ?? {})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  const save = () => {
    const debrief = { ...values, completedAt: new Date().toISOString() }
    updateRecord((record) => ({
      ...record,
      criticalCare: { ...(record.criticalCare || {}), debrief },
    }))
    onClose()
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      fullScreen={isMobile}
      onClick={(e) => e.stopPropagation()}
    >
      <DialogTitle>
        <Typography variant="h6" fontWeight={800}>
          Hot debrief
        </Typography>
        <Typography variant="body2" color="text.secondary">
          A few minutes together before the team splits up. Take stock, look
          after each other, and note anything to follow up.
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Stack gap={2}>
          {DEBRIEF_FIELDS.map((field) => (
            <Stack key={field.key} gap={0.5}>
              <Typography fontWeight={600}>{field.label}</Typography>
              {field.type === 'yesno' ? (
                <ToggleButtonGroup
                  exclusive
                  value={values[field.key] ?? null}
                  onChange={(e, next) =>
                    setValues((prev) => ({
                      ...prev,
                      [field.key]: next ?? undefined,
                    }))
                  }
                >
                  {['Yes', 'No'].map((option) => (
                    <ToggleButton
                      key={option}
                      value={option}
                      sx={{ minWidth: 96, height: 48, fontWeight: 700 }}
                    >
                      {option}
                    </ToggleButton>
                  ))}
                </ToggleButtonGroup>
              ) : (
                <TextField
                  value={values[field.key] ?? ''}
                  onChange={(e) =>
                    setValues((prev) => ({
                      ...prev,
                      [field.key]: e.target.value,
                    }))
                  }
                  multiline={field.type === 'textarea'}
                  minRows={field.type === 'textarea' ? 2 : undefined}
                  fullWidth
                />
              )}
            </Stack>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} size="large">
          Cancel
        </Button>
        <Button onClick={save} variant="contained" color="success" size="large">
          Save debrief
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DebriefDialog
